import { useContext } from 'react'

import CueLiveContentContext from '@contexts/cueLiveContent'

const useIsInCueLiveContent = (): boolean => !!useContext(CueLiveContentContext)

export default useIsInCueLiveContent
